"use client";
import { jsx as l } from "react/jsx-runtime";
import { memo as c } from "react";
import e from "../components/Icon/SvgIcon.js";
const t = (o) => /* @__PURE__ */ l(
  e,
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...o,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M21.799 19.932 13.866 12l7.932-7.932c.258-.258.27-.663.028-.905l-.989-.99c-.242-.24-.648-.229-.906.03L12 10.133 4.068 2.202c-.259-.258-.664-.27-.907-.029l-.988.99c-.243.242-.23.648.027.905L10.133 12l-7.93 7.932c-.259.258-.27.663-.029.905l.989.988c.241.244.648.23.904-.026L12 13.866l7.932 7.932c.258.258.663.27.905.027l.988-.988c.243-.242.232-.648-.026-.905",
        clipRule: "evenodd"
      }
    )
  }
), m = c(t);
export {
  m as XThin,
  m as default
};
